<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isAddress
                ? "userInfo.edit.address"
                : isPassword
                ? "userInfo.edit.password"
                : ""
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.back") }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <ValidationObserver ref="observer">
          <v-form>
            <v-card-text>
              <v-container>
<!--                &lt;!&ndash; 三级地址 &ndash;&gt;-->
<!--                <v-row align="center" v-if="isAddress">-->
<!--                  <v-col cols="3" class="font-weight-bold text-right">-->
<!--                    {{ $t("userInfo.shop_address") + $t("Global.colon") }}-->
<!--                    <Required :show="savable" mode="edit" />-->
<!--                  </v-col>-->
<!--                  <v-col cols="9" md="7">-->
<!--                    &lt;!&ndash; 三级地址 &ndash;&gt;-->
<!--                    <CitiesSelectGroup-->
<!--                      :masterItem="shopUser.shop"-->
<!--                      @provinceSelected="provinceSelected  = $event.id"-->
<!--                      @citySelected="citySelected = $event.id"-->
<!--                      @districtSelected="districtSelected = $event.id"-->
<!--                    />-->
<!--                    <ValidationProvider-->
<!--                      v-slot="{ errors }"-->
<!--                      :name="$t('userInfo.shop_address')"-->
<!--                      rules="required"-->
<!--                    >-->
<!--                      <v-text-field-->
<!--                        single-line-->
<!--                        v-model="shopUser.shop.address"-->
<!--                        :label="$t('userInfo.shop_address')"-->
<!--                        :error-messages="-->
<!--                          $resparse-->
<!--                          .getErrorMsgs(serverErrors, 'address')-->
<!--                          .concat(errors)-->
<!--                        "-->
<!--                      >-->
<!--                        <template v-slot:message="{ key, message }">-->
<!--                          <div :class="key == 0 ? 'danger&#45;&#45;text' : ''">-->
<!--                            {{ message }}-->
<!--                          </div>-->
<!--                        </template>-->
<!--                      </v-text-field>-->
<!--                    </ValidationProvider>-->
<!--                  </v-col>-->
<!--                </v-row>-->
                <v-row align="center" v-if="isPassword">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{$t("userInfo.old_password") + $t("Global.colon")}}
                    <Required :show="savable" mode="edit" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('userInfo.old_password')"
                      :rules="shopUser.new_password ? 'required|min:6' : 'min:6'"
                    >
                      <v-text-field
                        single-line
                        v-model="shopUser.old_password"
                        :error-messages="errors"
                        :append-icon="showOldPassword ? 'fa-eye' : 'fa-eye-slash'"
                        :type="showOldPassword ? 'text' : 'password'"
                        @click:append="showOldPassword = !showOldPassword"
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row align="center" v-if="isPassword">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{$t("userInfo.new_password") + $t("Global.colon")}}
                    <Required :show="savable" mode="edit" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('userInfo.new_password')"
                      rules="min:6"
                    >
                      <v-text-field
                        single-line
                        v-model="shopUser.new_password"
                        :error-messages="errors"
                        :append-icon="showNewPassword ? 'fa-eye' : 'fa-eye-slash'"
                        :type="showNewPassword ? 'text' : 'password'"
                        @click:append="showNewPassword = !showNewPassword"
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row align="center" v-if="isPassword">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{$t("userInfo.cfm_password") + $t("Global.colon")}}
                    <Required :show="savable" mode="edit" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('userInfo.cfm_password')"
                      :rules="cfmPassword()"
                    >
                      <v-text-field
                        single-line
                        v-model="shopUser.cfm_password"
                        :error-messages="errors.length == 0 ? [] : [$t('userInfo.edit.cfm_password_error')]"
                        :append-icon="showCfmPassword ? 'fa-eye' : 'fa-eye-slash'"
                        :type="showCfmPassword ? 'text' : 'password'"
                        @click:append="showCfmPassword = !showCfmPassword"
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-form>
        </ValidationObserver>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $emit('input', null);
                    $emit('mode', null);
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.back") }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="savable"
              >
                <v-btn
                  color="success"
                  block
                  :disabled="loading"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Required from "@/components/plugins/Required";
// import CitiesSelectGroup from "@/components/plugins/CitiesSelects";
import ShopUsers from "@/api/shop_users";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "EditDetail",

  props: ["value", "mode", "shopUser"],

  components: {
    Required,
    // CitiesSelectGroup,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    savable() {
      return this.mode == "editAddress" || this.mode == "editPassword";
    },
    isAddress() {
      return this.mode == "editAddress";
    },
    isPassword() {
      return this.mode == "editPassword";
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    serverErrors: [],
    provinceSelected: "",
    citySelected: "",
    districtSelected: "",
    showOldPassword: false,
    showNewPassword: false,
    showCfmPassword: false,
  }),

  methods: {
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            let postData = {};
            postData.mode = this.mode
            if (this.mode == 'editPassword'){
              postData.old_password = this.shopUser.old_password
              postData.password = this.shopUser.cfm_password
            }
            ShopUsers.edit(postData).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$emit('mode', null);
                  this.$emit('input', null);
                  this.$snackbar.success(i18n.t("userInfo.edit.saveSuccess"));
                }
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            )
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    cfmPassword() {
      return { equal: this.shopUser.new_password };
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        this.$scrollTop(); //返回顶部
      },
    },
  },
};
</script>